import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/ui/library/dropdown-menu";
import { cn } from "@/lib/utils";
import ImageWithFallback from "@/ui/ImageWithFallback";
import { ActiveEcosystemReturnType } from "@thrivecoin/adapter/dist/types";
import { useEcosystemContext } from "@/providers/EcosystemProvider";

const ALL_ECOSYSTEMS_ITEM = {
  id: 0,
  name: "All Ecosystems",
  logoUrl: "",
  slug: "",
};

const EcosystemSelector = () => {
  const { ecosystems, selectedEcosystem, onEcosystemChange } = useEcosystemContext();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="focus-visible:outline-none">
        <div className="inline-flex h-10 items-center justify-center gap-2 rounded-[100px] bg-[#191B20] px-4 py-2 text-sm font-normal leading-tight text-[#B8B8B8]/80">
          <ImageWithFallback
            type="ecosystem"
            src={selectedEcosystem?.logoUrl}
            alt={selectedEcosystem?.name}
            className="h-6 w-6 min-w-6 rounded-full object-contain"
          />
          {selectedEcosystem?.name || "All Ecosystems"}
        </div>
      </DropdownMenuTrigger>

      <DropdownMenuContent className="w-[200px]">
        <EcosystemItem item={ALL_ECOSYSTEMS_ITEM} onSelect={onEcosystemChange} />
        {ecosystems?.map((ecosystem) => (
          <EcosystemItem key={ecosystem.id} item={ecosystem} onSelect={onEcosystemChange} />
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

const EcosystemItem = ({
  item,
  onSelect,
}: {
  item: ActiveEcosystemReturnType;
  onSelect: (ecosystem: ActiveEcosystemReturnType) => void;
}) => {
  const { name, logoUrl } = item;

  return (
    <DropdownMenuItem
      className={cn("cursor-pointer p-0 font-medium text-white hover:text-black")}
      onClick={() => onSelect(item)}
    >
      <div className="flex w-full items-center gap-2 p-2">
        <ImageWithFallback
          type="ecosystem"
          src={logoUrl}
          alt={name}
          className="h-6 w-6 min-w-6 rounded-full object-contain"
        />
        <span>{name}</span>
      </div>
    </DropdownMenuItem>
  );
};

export default EcosystemSelector;
